'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAudit$002dView$0024$0024anon$00245 from "./presto.-Audit-View$$anon$5.js";
import * as $j_presto$002e$002dAudit$002dView$0024$002dAudit$002dName$0024 from "./presto.-Audit-View$-Audit-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$$anon$4() {
  this.aCa = null;
  this.aC2 = null;
  this.aC3 = false;
  this.aCb = null;
  this.aCc = false;
  this.aCf = null;
  this.aC8 = null;
  this.aC9 = false;
  this.aC4 = null;
  this.aC5 = false;
  this.aC6 = null;
  this.aC7 = false;
  this.aCd = false;
  this.aCe = false;
  this.aCa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aCf = "AuditName";
}
export { $c_Lpresto_AuditView$$anon$4 as $c_Lpresto_AuditView$$anon$4 };
$p = $c_Lpresto_AuditView$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$$anon$4;
/** @constructor */
function $h_Lpresto_AuditView$$anon$4() {
}
export { $h_Lpresto_AuditView$$anon$4 as $h_Lpresto_AuditView$$anon$4 };
$h_Lpresto_AuditView$$anon$4.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aCa;
});
$p.M = (function() {
  if ((!this.aC3)) {
    this.aC2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aC3 = true;
  }
  return this.aC2;
});
$p.O = (function() {
  if ((!this.aCc)) {
    this.aCb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aCc = true;
  }
  return this.aCb;
});
$p.D = (function() {
  return this.aCf;
});
$p.t = (function() {
  if ((!this.aC9)) {
    this.aC8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aC9 = true;
  }
  return this.aC8;
});
$p.N = (function() {
  if ((!this.aC5)) {
    this.aC4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aq, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aC5 = true;
  }
  return this.aC4;
});
$p.Q = (function() {
  if ((!this.aC7)) {
    this.aC6 = new $j_presto$002e$002dAudit$002dView$0024$0024anon$00245.$c_Lpresto_AuditView$$anon$5();
    this.aC7 = true;
  }
  return this.aC6;
});
$p.v = (function() {
  if ((!this.aCe)) {
    this.aCd = false;
    this.aCe = true;
  }
  return this.aCd;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee70) => ((p) => \u03b4scrutinee70.cGW(p)))($j_presto$002e$002dAudit$002dView$0024$002dAudit$002dName$0024.$m_Lpresto_AuditView$AuditName$())));
});
var $d_Lpresto_AuditView$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$$anon$4, "presto.AuditView$$anon$4", ({
  EG: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AuditView$$anon$4 as $d_Lpresto_AuditView$$anon$4 };
//# sourceMappingURL=presto.-Audit-View$$anon$4.js.map
